import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { ComponentData, TabData } from '@ddt-web/data-service';
import * as get from 'lodash/get';

@Component({
	selector: 'risk-alternative-deep-dive',
	templateUrl: './alternative-deep-dive.component.html',
	styleUrls: ['./alternative-deep-dive.component.scss']
})
export class AlternativeDeepDiveComponent implements OnInit, OnChanges {

	@Input() public data: ComponentData;

	public asOfDate: string;
	public asOfDateSNP: string;
	public activeSumTab: TabData;
	public totalSumTab: TabData;
	public decompHeaderTab: TabData;
	public decompositionTabs: TabData[] = [];
	public subTitle: string;
	public title: string;

	constructor(private contentService: ContentService) { }

	public ngOnInit(): void {
		this.subTitle = this.contentService.get('ALTERNATIVES_DEEP_DIVE_SUBTITLE', 'ALTERNATIVES_DEEP_DIVE_SUBTITLE');
		this.title = this.contentService.get('ALTERNATIVES_DEEP_DIVE_TITLE', 'Alternatives Deep Dive');
	}

	public ngOnChanges(): void {
		if (this.data && this.data.success) {
			const asOfDateTab = this.data.getTabById('risk.asOfDate');
			this.asOfDate = get(asOfDateTab, 'displayConfig.visible') && get(asOfDateTab, 'tableData[0].cells[0][0].formattedValue');
			const asOfDateSNPTab = this.data.getTabById('risk.asOfDate.snp');
			this.asOfDateSNP = get(asOfDateSNPTab, 'displayConfig.visible') && get(asOfDateSNPTab, 'tableData[0].cells[0][0].formattedValue');
			this.activeSumTab = this.data.getTabById('alternatives.active.risk.sum');
			this.totalSumTab = this.data.getTabById('alternatives.risk.sum');
			this.decompHeaderTab = this.data.getTabById('alternatives.risk.decomposition.header');
			const multiAssetActiveRiskDecompTab = this.data.getTabById('alternatives.active.risk.decomposition');
			const multiAssetTotalRiskDecompTab = this.data.getTabById('alternatives.risk.decomposition');
			if (multiAssetTotalRiskDecompTab) {
				this.decompositionTabs.push(multiAssetTotalRiskDecompTab);
			}
			if (multiAssetActiveRiskDecompTab) {
				this.decompositionTabs.push(multiAssetActiveRiskDecompTab);
			}
		}
	}

}
